import { gql } from "@apollo/client";

export const FETCH_PLAN_FOR_INC_ODOO = gql`
  query FETCH_PLAN_FOR_INC_ODOO($planId: ID!) {
    productionPlan(id: $planId) {
      id
      planType
      odooIncSo {
        id
        objectId
        objectName
      }
      odooIncPo {
        id
        objectId
        objectName
      }

      extraData
      lines {
        id
        product {
          id
          name
          number
        }
        finalQty
      }
      validChildren {
        id
        state
        lines {
          product {
            id
            name
            number
          }
          finalQty
        }
      }
    }
  }
`;

export const SAVE_PLAN_EXTRA_DATA = gql`
  mutation SAVE_PLAN_EXTRA_DATA($planId: ID!, $extraData: String!) {
    saveProductionPlan(planId: $planId, extraData: $extraData) {
      productionPlan {
        id
        extraData
      }
    }
  }
`;

export const FETCH_PLAN_SUMMARY_AND_ODOO_SO_DETAIL = gql`
  query FETCH_PLAN_SUMMARY_AND_ODOO_SO_DETAIL($id: ID!, $soId: Int!) {
    productionPlan(id: $id) {
      id
      orderType
      extraData
      lines {
        id
        product {
          id
          odooIdInc
          name
          number
        }
        unitCost
        totalCost
        finalQty
      }
      validChildren {
        id
        state
        lines {
          id
          product {
            id
            odooIdInc
            name
            number
          }
          unitCost
          totalCost
          finalQty
        }
      }
    }
    odooSo(instance: "INC", ids: [$soId], useType: "OS_COMPARE")
  }
`;

export const FETCH_PLAN_SUMMARY_AND_ODOO_PO_DETAIL = gql`
  query FETCH_PLAN_SUMMARY_AND_ODOO_PO_DETAIL($id: ID!, $poId: Int!) {
    productionPlan(id: $id) {
      id
      orderType
      extraData
      finalLines {
        id
        product {
          id
          odooIdInc
          name
          number
        }
        salesPrice
        finalQty
        discountPercentage
        totalPrice
      }
    }
    odooPo(instance: "INC", ids: [$poId], useType: "OS_COMPARE")
  }
`;
